// Derived from the hostname rather than import.meta.env.MODE: the dev host and
// prod are served from the same production build, so MODE reads "production" on
// both. Lives outside instrument.ts so it can be tested without triggering
// Sentry.init's import-time side effect.
export function resolveSentryEnvironment(hostname: string): string {
  if (/^(localhost|127\.0\.0\.1)$/.test(hostname)) return "local";
  if (hostname.startsWith("dev.")) return "devhost";
  return "production";
}
